module.exports = __webpack_public_path__ + "static/media/IconosGas-01.4c9cf2ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gas/IconosGas-01.svg
// module id = 745
// module chunks = 0